export const INTEGRATIONS_SERVER = 'SERVER';
export const INTEGRATIONS_DEVICE = 'DEVICE';

export const INTEGRATIONS_SERVER_LIST = 'INTEGRATIONS_SERVER_LIST';
export const INTEGRATIONS_DEVICE_LIST = 'INTEGRATIONS_DEVICE_LIST';

export const INTEGRATIONS_SERVER_VIEW = 'INTEGRATIONS_SERVER_VIEW';
export const INTEGRATIONS_DEVICE_VIEW = 'INTEGRATIONS_DEVICE_VIEW';
